export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/arrow.8065e5d9.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};